import URI from 'urijs'
import Vue from 'vue'
import store from '@/src/server/plugins/store'

Vue.use({
  install (Vue) {
    // Filters
    Vue.prototype.$filters = Vue.options.filters

    Vue.prototype.$filters.ellipsis = (value, length = 600) => {
      if (value.length > length) {
        return value.substr(0, length)
      } else {
        return value
      }
    }

    Vue.prototype.$filters.stripHtml = (value) => {
      let wrapper = document.createElement('div')

      wrapper.innerHTML = value

      return wrapper.textContent || wrapper.innerText || ''
    }

    // Methods
    Vue.prototype.linkTarget = (url, avoidTopTarget = false) => {
      if (avoidTopTarget) {
        return '_blank'
      }

      return Vue.prototype.sameClientDomain(url) ? '_top' : '_blank'
    }

    Vue.prototype.sameClientDomain = (url) => {
      return Vue.prototype.sameDomain(store.clientUrl, url)
    }

    Vue.prototype.sameDomain = (urlA, urlB) => {
      return new URI(urlA || '').host() === new URI(urlB || '').host()
    }
  },
})



// WEBPACK FOOTER //
// ./src/server/plugins/helpers.js